import { useMutation } from 'react-query'
import hooks from '../../../hooks'

const useCourseDelete = ({
    courseId,
    onSuccess = () => {}
}) => {
    
    const cacheKeys = hooks.useCacheKeys()
    
    const { toastError, toastSuccess } = hooks.useToasts({ successMessage: 'Experience deleted!', onSuccess })

    const { clearCache } = hooks.useCache({ key: cacheKeys.COURSES, onReload: toastSuccess })
    
    const { api, endpoints, url } = hooks.useApi()

    const [ deleteCourse, { isLoading }] = useMutation(
        () => api.delete(url(endpoints.course, { courseId })),
        {
            onSuccess: clearCache,
            onError: toastError
        }
    )

    const { showConfirmation } = hooks.useConfirmationDialog({
        confirmLabel: 'Delete',
        title: 'Delete Experience?',
        description: 'Are you sure you want to delete this experience?',
        onConfirm: deleteCourse
    })

    return {
        deleteCourse: showConfirmation,
        isDeletingCourse: isLoading
    }
}

export default useCourseDelete
